module.exports = __webpack_public_path__ + "static/media/0323_IMG_FE_LES_MURS_P21_UNI_CARVAO_CHEVRON.81a1ac2d.webp";